var config = {
  "us": {
    "chatServer": "wss://chat.elbetdev.com:8765",
    "gameServers": "https://server.rocketman.us.elbetdev.com:9223"
  },
  "retail": {
    "chatServer": "wss://chat.elbetdev.com:8765",
    "gameServers": "wss://server.rsretail.elbetdev.com:9111/ws/connect_visual"
  },
  "default": {
    "chatServer": "wss://chat.elbetdev.com:8765",
    "gameServers": "https://server.rocketman.elbetdev.com:9223"
  },
  "env": {
    "chatServer": "wss://chat.elbetdev.com:8765",
    "gameServers": "https://server.stage.rocketmanretail.elbetdev.com:9001"
  }
}
export default config;